import { CalendarClock, Send, Workflow } from 'lucide-react';
import { EntityListCard, type EntityListCardBadge } from '@/shared/components/entity-list-card';
import { PassbookLogoThumb } from '@/shared/components/passbook-logo-thumb';
import type { AgendaClientGroup } from '../model/group-by-client';

interface AgendaClientCardProps {
  group: AgendaClientGroup;
  index: number;
  onOpen: () => void;
}

export function AgendaClientCard({ group, index, onOpen }: AgendaClientCardProps) {
  const badges: EntityListCardBadge[] = [
    {
      key: 'count',
      label: `${group.campaigns.length} campanha${group.campaigns.length === 1 ? '' : 's'}`,
      icon: Workflow,
      variant: 'info',
      copyLines: [
        {
          label: 'Campanhas no filtro',
          value: String(group.campaigns.length),
        },
      ],
    },
    ...(group.nextChannel
      ? [
          {
            key: 'channel',
            label: group.nextChannel,
            icon: Send,
            variant: 'accent' as const,
            copyLines: [{ label: 'Canal do próximo', value: group.nextChannel }],
          },
        ]
      : []),
    {
      key: 'next',
      label: group.nextRunLabel,
      icon: CalendarClock,
      variant: 'default',
      wide: true,
      copyLines: [
        { label: 'Próximo disparo', value: group.nextRunLabel },
        { label: 'Campanha', value: group.nextCampaignName },
      ],
    },
  ];

  return (
    <EntityListCard
      selected={false}
      onToggle={() => {}}
      index={index}
      selectable={false}
      onCardClick={onOpen}
      ariaLabel={`Abrir campanhas de ${group.clientName}`}
      title={group.clientName}
      subtitle={
        <span className="truncate text-sm text-muted-foreground">{group.nextCampaignName}</span>
      }
      thumbnail={
        <PassbookLogoThumb
          passbookId={group.passbookId}
          name={group.clientName}
          backgroundColor={group.backgroundColor}
        />
      }
      badges={badges}
      badgesBelow
      actions={null}
    />
  );
}
